import SwankySwatchBox from 'components/productdetail/swankyswatch/SwankySwatchBox';
import SwankySwatchBoxTreatment from 'components/productdetail/swankyswatch/SwankySwatchBoxTreatment';
import { FEATURE_PDP_COLOR_TWISTER } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';

export const SwankySwatchBoxManager = (props: React.ComponentProps<typeof SwankySwatchBox>) => {
  const { isEnrolled: isHorizontalScrollingTreatment } = useIsEnrolledInVariant(FEATURE_PDP_COLOR_TWISTER, 'horizontal-scroll');
  const { isEnrolled: isExpandableGridTreatment } = useIsEnrolledInVariant(FEATURE_PDP_COLOR_TWISTER, 'expanded-scroll');

  if (isHorizontalScrollingTreatment) {
    return <SwankySwatchBoxTreatment {...props} initialMode="carousel" />;
  }

  if (isExpandableGridTreatment) {
    const initialMode = props.styleList.length <= 9 ? 'grid' : 'carousel';

    return <SwankySwatchBoxTreatment {...props} initialMode={initialMode} />;
  }

  return <SwankySwatchBox {...props} />;
};
